import { render } from "./Profile.vue?vue&type=template&id=99c24784"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"
script.render = render

export default script